import { CtaBand } from "../components/CtaBand";
import { FeatureGrid } from "../components/FeatureGrid";
import { PageHeader } from "../components/PageHeader";

export function FeaturesPage() {
  return (
    <>
      <PageHeader
        eyebrow="Features"
        title="Made for SEND family life"
        lead="Use what helps and ignore the rest. Every part of SENfully works on its own, and even better together."
      />
      <div className="container page-body">
        <FeatureGrid />
      </div>
      <CtaBand />
    </>
  );
}
